/** Mirrors server `KB_CATEGORIES` — single source for browse + upload UI. */

export const KB_CATEGORY_OPTIONS = [
  { value: 'general_manuals', label: 'General manuals' },
  { value: 'technical_reference', label: 'Technical reference' },
  { value: 'bms_controls_plc', label: 'BMS / controls / PLC' },
  { value: 'educational', label: 'Educational' },
  { value: 'model_forms', label: 'Model forms' },
  { value: 'business_financial', label: 'Business / financial' },
  { value: 'bsi_iet', label: 'BSI / IET' },
  { value: 'best_practice_guides', label: 'Best practice guides' },
];

/** Categories where the manufacturer A–Z rail is shown in browse. */
export const KB_MANUFACTURER_INDEX_CATEGORIES = new Set([
  'general_manuals',
  'technical_reference',
  'bms_controls_plc',
]);

/** Categories that require manufacturer on upload (server-enforced). */
export const KB_MANUFACTURER_REQUIRED_CATEGORIES = KB_MANUFACTURER_INDEX_CATEGORIES;

export function kbCategoryLabel(value) {
  if (!value) return '—';
  return KB_CATEGORY_OPTIONS.find((c) => c.value === value)?.label ?? value;
}
